import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";

export const CLOSED_POSITIONS_KEY = ["positions", "closed"] as const;

// Закрытые (погашенные/распроданные) позиции. Нужны календарю, чтобы показать
// прошлые купоны и дату погашения — из основного портфеля они выпадают.
export function useClosedPositions() {
  return useQuery({
    queryKey: CLOSED_POSITIONS_KEY,
    queryFn: async ({ signal }) => {
      const { data, error } = await api.GET("/api/positions/closed", { signal });
      if (error || !data) throw new Error(String(error ?? "no data"));
      return data;
    },
    staleTime: 30_000,
  });
}
